/* eslint-disable import/no-unresolved */
import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import { BrandDetailsProvider } from 'dw-au-react-components';
import BlogDetail from './pages/BlogDetail';
import { ContentfulProvider } from './context/Contentful';
import CategoryBlogs from './pages/CategoryBlog';

const App = () => {
	return (
		<BrandDetailsProvider brandTag='wpe'>
			<ContentfulProvider>
				<Router>
					<Switch>
						<Route path='/blog/:category' exact>
							<CategoryBlogs />
						</Route>
						<Route path='/blog/:category/:slug' exact>
							<BlogDetail />
						</Route>
						<Route path='/'>
							<LandingPage />
						</Route>
					</Switch>
				</Router>
			</ContentfulProvider>
		</BrandDetailsProvider>
	);
};

ReactDOM.render(<App />, document.getElementById('blog__page'));
